import React, { useEffect, useState } from "react";
import img1 from "../../assets/images/Home/Before1.webp";
import img2 from "../../assets/images/Home/After1.webp";
import img3 from "../../assets/images/Home/Before2.png";
import img4 from "../../assets/images/Home/After2.png";
import img5 from "../../assets/images/Home/Before3.jpg";
import img6 from "../../assets/images/Home/After3.jpg";
import img7 from "../../assets/images/Home/Before4.png";
import img8 from "../../assets/images/Home/After4.png";
import img9 from "../../assets/images/Home/Before5.png";
import img10 from "../../assets/images/Home/After5.png";
import img11 from "../../assets/images/Home/Before6.png";
import img12 from "../../assets/images/Home/After6.png";
import img13 from "../../assets/images/Home/Before7.png";
import img14 from "../../assets/images/Home/After7.png";


import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Homesec3 = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
    };

    const content = {
        English: {
            heading: "Conservation & Preservation",
            learnMore: "Learn More →",
            data: [
                {
                    id: "ausa-fort",
                    images: [
                        { id: "ausa-before", src: img1, name: "Before" },
                        { id: "ausa-after", src: img2, name: "After" },
                    ],
                    heading: "Ausa fort - Ausa, Dist. Latur",
                },
                {
                    id: "yashwantrao-chavan",
                    images: [
                        { id: "yashwantrao-before", src: img3, name: "Before" },
                        { id: "yashwantrao-after", src: img4, name: "After" },
                    ],
                    heading: "Yashwantrao Chavan Memorial, Devrashtre",
                },
                {
                    id: "bandra-fort",
                    images: [
                        { id: "bandra-before", src: img5, name: "Before" },
                        { id: "bandra-after", src: img6, name: "After" },
                    ],
                    heading: "Bandra Fort, Bandra, Dist. Mumbai",
                },
                {
                    id: "kanhoji-angre",
                    images: [
                        { id: "kanhoji-before", src: img7, name: "Before" },
                        { id: "kanhoji-after", src: img8, name: "After" },
                    ],
                    heading:
                        "Kanhoji Angre Samadhi, Alibaug, Dist. Raigad (Ratnagiri Division)",
                },
                {
                    id: "mahadev-temple",
                    images: [
                        { id: "mahadev-before", src: img9, name: "Before" },
                        { id: "mahadev-after", src: img10, name: "After" },
                    ],
                    heading: "Mahadev Temple, Hottal, Dist. Nanded",
                },
                {
                    id: "rangamahal",
                    images: [
                        { id: "rangamahal-before", src: img11, name: "Before" },
                        { id: "rangamahal-after", src: img12, name: "After" },
                    ],
                    heading: "Rangamahal, Chandwad, Dist. Nashik",
                },
                {
                    id: "rasalghad-fort",
                    images: [
                        { id: "rasalghad-before", src: img13, name: "Before" },
                        { id: "rasalghad-after", src: img14, name: "After" },
                    ],
                    heading: "Rasalghad Fort, Dist. Ratnagiri",
                },
            ],
        },

        मराठी: {
            heading: "संवर्धन आणि जतन",
            learnMore: "अधिक वाचा →",
            data: [
                {
                    id: "ausa-fort",
                    images: [
                        { id: "ausa-before", src: img1, name: "पूर्वी" },
                        { id: "ausa-after", src: img2, name: "नंतर" },
                    ],
                    heading: "औसा किल्ला - औसा, जि. लातूर",
                },
                {
                    id: "yashwantrao-chavan",
                    images: [
                        { id: "yashwantrao-before", src: img3, name: "पूर्वी" },
                        { id: "yashwantrao-after", src: img4, name: "नंतर" },
                    ],
                    heading: "यशवंतराव चव्हाण स्मारक, देवरेष्टे",
                },
                {
                    id: "bandra-fort",
                    images: [
                        { id: "bandra-before", src: img5, name: "पूर्वी" },
                        { id: "bandra-after", src: img6, name: "नंतर" },
                    ],
                    heading: "बांद्रा किल्ला, बांद्रा, जि. मुंबई",
                },
                {
                    id: "kanhoji-angre",
                    images: [
                        { id: "kanhoji-before", src: img7, name: "पूर्वी" },
                        { id: "kanhoji-after", src: img8, name: "नंतर" },
                    ],
                    heading: "कान्होजी आंग्रे समाधी, अलीबाग, जि. रायगड (रत्नागिरी विभाग)",
                },
                {
                    id: "mahadev-temple",
                    images: [
                        { id: "mahadev-before", src: img9, name: "पूर्वी" },
                        { id: "mahadev-after", src: img10, name: "नंतर" },
                    ],
                    heading: "महादेव मंदिर, होतळ, जि. नांदेड",
                },
                {
                    id: "rangamahal",
                    images: [
                        { id: "rangamahal-before", src: img11, name: "पूर्वी" },
                        { id: "rangamahal-after", src: img12, name: "नंतर" },
                    ],
                    heading: "रंगमहल, चांदवड, जि. नाशिक",
                },
                {
                    id: "rasalghad-fort",
                    images: [
                        { id: "rasalghad-before", src: img13, name: "पूर्वी" },
                        { id: "rasalghad-after", src: img14, name: "नंतर" },
                    ],
                    heading: "रसलगड किल्ला, जि. रत्नागिरी",
                },
            ],
        },
    };

    const langContent = content[selectedLang];
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentGroup = langContent.data[currentIndex];

    // const handleScroll = (direction) => {
    //     if (direction === "left" && currentIndex + 1 < langContent.data.length) {
    //         setCurrentIndex(currentIndex + 1);
    //     } else if (direction === "right" && currentIndex - 1 >= 0) {
    //         setCurrentIndex(currentIndex - 1);
    //     }
    // };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) =>
                prev + 1 < langContent.data.length ? prev + 1 : 0
            );
        }, 2000);

        return () => clearInterval(interval);
    }, [langContent.data.length]);

    return (
        <div className="flex flex-col items-center justify-center px-4 py-2 md:py-5 lg:py-10 mt-4">
            {/* Top Heading */}
            <div className="text-center mb-8 py-7">
                <h2 className="text-xl sm:text-2xl md:text-3xl -mt-4 lg:-mt-16">
                    {langContent.heading}
                </h2>
            </div>


            {/* Main bordered container */}
            <div className="w-full max-w-5xl border-gray-300 shadow-lg rounded-xl p-6 sm:p-8 -mt-20 -sm:mt-4">
                {/* Arrows and Images */}
                <div className="relative flex items-center justify-center mb-8">

                    {/* Left Button */}
                    {/* <button
                        className="absolute left-0 top-1/2 -translate-y-1/2 
                 w-8 h-8 flex items-center justify-center 
                 disabled:opacity-50 no-btn icon-btn"
                        onClick={() => handleScroll("right")}
                        disabled={currentIndex === 0}
                    >
                        <img src={rightarrow} alt="Right" className="w-4 h-4 mb-6 mr-10 md:mr-6 yellow-icon" />
                    </button> */}

                    {/* Images */}
                    <div className="flex flex-wrap lg:flex-nowrap justify-center gap-4 sm:gap-8 w-full">
                        {currentGroup.images.map((img) => (
                            <div
                                key={img.id}
                                className="text-center w-full sm:w-[220px] md:w-[400px]"
                            >
                                <img
                                    src={img.src}
                                    alt={img.name}
                                    className="
        w-full h-48 sm:h-56 rounded-lg mb-2
        transition-all duration-1000 ease-in-out
        opacity-100 scale-100
    "                                />
                                <p className="text-sm font-medium text-gray-700 transition-opacity duration-700">{img.name}</p>
                            </div>
                        ))}
                    </div>

                    {/* Right Button */}
                    {/* <button
                        className="absolute right-0 top-1/2 -translate-y-1/2 
                 w-8 h-8 flex items-center justify-center 
                 disabled:opacity-50 no-btn icon-btn"
                        onClick={() => handleScroll("left")}
                        disabled={currentIndex + 1 >= langContent.data.length}
                    >
                        <img src={leftarrow} alt="Left" className="w-4 h-4 mb-6 ml-10 md:ml-6 yellow-icon" />
                    </button>*/}
                </div>

                {/* Dynamic Heading + Description */}
                <div className="text-center mt-4 max-w-[700px] mx-auto">
                    <h3 className="
    text-xl font-semibold text-gray-800 mb-2
    transition-all duration-700 ease-in-out
">                        {currentGroup.heading}
                    </h3>

                    <button
                        onClick={() => handleNavigate("/conversation")}
                        className="mt-3 sm:mt-5 
      px-3 sm:px-5 
      py-1 sm:py-2 
      text-[8px] sm:text-[11px] md:text-sm 
      bg-transparent border border-[#2c1b07] text-[#2c1b07] 
      rounded-full 
      hover:bg-orange-500 hover:text-white 
      hover:border-transparent transition"
                    >
                        {langContent.learnMore}
                    </button>
                </div>
            </div>

        </div>
    );
};

export default Homesec3;
